import { useQuery } from '@tanstack/react-query';
import { getSalesZone } from 'services/api/requests/requests';

export const useSalesZoneList = () => {
	return useQuery(['salesZone-list'], getSalesZone, {
		refetchOnWindowFocus: false,
	});
};
